import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import * as ErpSourceList from 'types/_general/Store/ErpSourceList';

const rb = new ReducerBuilder<ErpSourceList.Type>();

export const createErpSourceListLoadedAction = rb.createActionForReducer<ErpSourceList.Type>(
	payloadReducer((x) => x),
	'ErpSourceList/LoadedFromBackend'
);

export const erpSourceListReducer = rb.createReducer();
